import { PDFDocument, StandardFonts, degrees, rgb } from "pdf-lib";

export const addCopyWatermark = async (
	pdfBlob: Blob,
	text: string = "KOPIE"
): Promise<Blob> => {
	const arrayBuffer = await pdfBlob.arrayBuffer();
	const pdfDoc = await PDFDocument.load(arrayBuffer);
	const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
	const fontSize = 140;
	const textWidth = font.widthOfTextAtSize(text, fontSize);
	const textHeight = font.heightAtSize(fontSize);

	for (const page of pdfDoc.getPages()) {
		const { width, height } = page.getSize();
		const angleDeg = 45;
		const angleRad = (angleDeg * Math.PI) / 180;
		const x =
			width / 2 -
			(textWidth / 2) * Math.cos(angleRad) +
			(textHeight / 2) * Math.sin(angleRad);
		const y =
			height / 2 -
			(textWidth / 2) * Math.sin(angleRad) -
			(textHeight / 2) * Math.cos(angleRad);
		page.drawText(text, {
			x,
			y,
			size: fontSize,
			font,
			color: rgb(0.7, 0.7, 0.7),
			opacity: 0.35,
			rotate: degrees(angleDeg),
		});
	}

	const bytes = await pdfDoc.save();
	return new Blob([bytes.buffer as ArrayBuffer], {
		type: "application/pdf",
	});
};
